// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.gds.GraphicalDataSourceObject
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { Message } from "abweb/dto/Message";
import { NamedDataSourceRecordReference } from "abweb/dto/gds/NamedDataSourceRecordReference";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { KendoObservableObjectProxy } from "abweb/dto/kendo/KendoObservableObjectProxy";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class GraphicalDataSourceObjectBase extends KendoObservableObjectProxy {
  /** Do NOT invoke directly, instead use strongly typed createGraphicalDataSourceObjectBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.GraphicalDataSourceObject";
  }
  initFromJson(json, deserializeContext) {
    this.initGraphicalDataSourceObject(TSOGUtils.decodeObject(json.dataSourceRecordReference, NamedDataSourceRecordReference, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "dataSourceRecordReference")), json.id != null ? json.id : null, json.messages != null ? TSOGUtils.decodeObjectArray(json.messages, Message, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "messages")) : null, json.state != null ? DataSourceState.fromJson(json.state) : null, json.styleClasses != null ? json.styleClasses : null, json.viewType != null ? json.viewType : null);
  }
  initGraphicalDataSourceObject(dataSourceRecordReference, id, messages, state, styleClasses, viewType) {
    this.initKendoObservableObjectProxy();
    this._dataSourceRecordReference = dataSourceRecordReference;
    this._id = id;
    this._messages = messages;
    this._state = state;
    this._styleClasses = styleClasses;
    this._viewType = viewType;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._dataSourceRecordReference != null) {
      retVal["dataSourceRecordReference"] = TSOGUtils.toTSOGNativeObject(this._dataSourceRecordReference, serializeContext);
    }
    retVal["id"] = this._id;
    if (this._messages != null) {
      retVal["messages"] = TSOGUtils.toTSOGArray(this._messages, serializeContext);
    }
    retVal["state"] = this._state;
    retVal["styleClasses"] = this._styleClasses;
    retVal["viewType"] = this._viewType;
    return retVal;
  }
  get dataSourceRecordReference() {
    return this._dataSourceRecordReference;
  }
  set dataSourceRecordReference(value) {
    this._dataSourceRecordReference = value;
  }
  get id() {
    return this._id;
  }
  set id(value) {
    this._id = value;
  }
  get messages() {
    return this._messages;
  }
  set messages(value) {
    this._messages = value;
  }
  get state() {
    return this._state;
  }
  set state(value) {
    this._state = value;
  }
  get styleClasses() {
    return this._styleClasses;
  }
  set styleClasses(value) {
    this._styleClasses = value;
  }
  get viewType() {
    return this._viewType;
  }
  set viewType(value) {
    this._viewType = value;
  }
}
//# sourceMappingURL=GraphicalDataSourceObjectBase.js.map
